import React from 'react';
import {useRoutes} from 'react-router-dom';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.scss';
import {AccountContextProvider, AccountRegistrationProvider} from './contexts';
import {GiveRecco, Home, OnboardingPage} from './pages';
import Aura from './pages/aura';

const App: React.FC = () => {
  const element = useRoutes([
    {path: '/', element: <Home />},
    {path: '/give-recco', element: <GiveRecco />},
    {path: '/aura', element: <Aura />},
    {path: '/onboarding', element: <OnboardingPage />},
  ]);

  return (
    <AccountRegistrationProvider>
      <AccountContextProvider>
        <div className="App">
          {element}
          <ToastContainer />
        </div>
      </AccountContextProvider>
    </AccountRegistrationProvider>
  );
};
export default App;
